import { jsx as _jsx } from "react/jsx-runtime";
import { useMemo } from 'react';
import { standaloneSubmitSectionItemsStyles, StandaloneSubmitSectionWrapper } from './styled';
export const StandaloneSubmitSection = (props) => {
    const itemsStyles = useMemo(() => `${standaloneSubmitSectionItemsStyles} ${props.itemsStyles}`, [props.itemsStyles]);
    return _jsx(StandaloneSubmitSectionWrapper, { ...props, itemsStyles: itemsStyles });
};
